import { useEffect, useState, useMemo } from 'react';

import { getGiftcard } from '../helpers/giftcard';

import { useConfigContext } from '../context/ConfigContext';
import { GiftCardContext } from '../context/GiftCardContext';
import { useStateValue } from '../hooks/UseStateValue';

import { TProvider } from '../interfaces/interfaces';

/* ========================================= Local Functions ========================================= */
const useFetchGiftcard = () => {
    const [
        {
            selection: { partner }
        },
        dispatch
    ] = useStateValue();
    const config = useConfigContext();

    useEffect(() => {
        if (partner !== undefined) {
            getGiftcard({
                giftcardEndpoint: config.endpoint.giftcard,
                product: config.product,
                partner,
                dispatch
            });
        }
    }, [partner, config, dispatch]);
};

/* ========================================= Main Component ========================================= */
const GiftCardProvider = ({ children }: TProvider) => {
    const [{ model, labels }] = useStateValue();
    const config = useConfigContext();
    const [showGiftCard, setShowGiftCard] = useState<boolean>(false);
    const [data, setData] = useState<any>({});
    const [strings, setStrings] = useState<any>({});

    useFetchGiftcard();

    useEffect(() => {
        if (labels[config.product]?.giftcard) {
            setStrings(labels[config.product].giftcard);
        }

        if (model[config.product]?.giftcard) {
            setData(model[config.product].giftcard);
        }
    }, [model, config.product, labels]);

    useEffect(() => {
        if (!!Object.keys(data).length && !!Object.keys(strings).length && data.status === 'active') {
            setShowGiftCard(true);
        }
    }, [data, strings]);

    const items = useMemo(
        () => ({
            showGiftCard,
            data,
            strings
        }),
        [showGiftCard, data, strings]
    );

    return <GiftCardContext.Provider value={items}>{children}</GiftCardContext.Provider>;
};

export default GiftCardProvider;
